import { render, staticRenderFns } from "./PrintMatricial.vue?vue&type=template&id=0e5c0666&scoped=true&"
import script from "./PrintMatricial.vue?vue&type=script&lang=js&"
export * from "./PrintMatricial.vue?vue&type=script&lang=js&"
import style0 from "./PrintMatricial.vue?vue&type=style&index=0&id=0e5c0666&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5c0666",
  null
  
)

export default component.exports